import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { DIVISIONS_KEY } from '../../../../../../api/services/divisions';
import usePlanStore from '../../../../../../store/planStore';
import { Countries } from '../../../../../../shared/enums';
import { getTouchpoints } from '../../../../../../api/services/mediaPlanning/touchpoints';
import prepareAvailableTouchpoints from '../utils/prepareAvailableTouchpoints';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';

const useTouchpoints = () => {
  const {
    generalInfoState,
    countryForms,
    selectedCountry,
    selectedCountryISOCode,
    updateCountryForm,
  } = usePlanStore();

  const { showError } = useError();

  const selectedCountryFormSubset = usePlanStore((state) => {
    const form = state.savedCountryForms[state.selectedCountry!];
    return form
      ? {
          targetGroup: form.targetGroup,
          campaignScenario: form.campaignScenario,
          segments: form.segments,
          startDate: form.startDate,
          campaignLength: form.campaignLength,
          isTVIncluded: form.isTVIncluded,
        }
      : null;
  }, shallow);

  const [isoCode, setIsoCode] = useState<string | null>(selectedCountryISOCode);

  useEffect(() => {
    setIsoCode(selectedCountryISOCode);
  }, [selectedCountryISOCode]);

  const { data: response, isFetching } = useQuery(
    [
      DIVISIONS_KEY,
      isoCode,
      generalInfoState.division,
      selectedCountryFormSubset,
    ],
    () => {
      return getTouchpoints(
        generalInfoState.division,
        generalInfoState.brand,
        generalInfoState.category,
        isoCode as Countries,
        countryForms[selectedCountry!].targetGroup,
        countryForms[selectedCountry!].campaignScenario,
        countryForms[selectedCountry!].isTVIncluded
      );
    },
    {
      enabled: !!isoCode && !!generalInfoState.division,
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Unknown error';
        showError(errorMessage);
      },
      onSuccess: (res) => {
        updateCountryForm(selectedCountry!, {
          availableTouchpoints: res.data,
        });
      },
    }
  );

  const touchpoints = response?.data || [];
  const uniqueTouchpoints = prepareAvailableTouchpoints(touchpoints);
  return { data: touchpoints, isFetching };
};

export default useTouchpoints;
